import { LABELS } from "~/resources/Labels";
import { ComponentRequest} from "~/models/Commons ";
import { SIMPLInput } from "../../../../components/commons/input/SIMPLInput";
import { SIMPLDialog } from "../../../../components/commons/dialog/SimplDialog";
import { SIMPLButtonCustomized } from "../../../../components/commons/button/SIMPLButtonCustumized";
import { UseVmComponentsForm } from "../vm-configuration/UseVmComponentsForm";
import { getComponentNumber } from "~/Utils/Utils";
import { MESSAGES } from "~/resources/Message";

interface Prop {
  onCloseModal: () => void;
  editedItem: ComponentRequest | null;
  setConfig: Function;
  title?: string;
  refetch: () => void;
}

export const AddVmPolicies = ({
  onCloseModal,
  editedItem,
  setConfig,
  title,
  refetch
}: Prop) => {
  const { handleSubmit, control, errors, submitForm } =
    UseVmComponentsForm(onCloseModal,refetch);

 const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
   event.preventDefault();
   handleSubmit((formData: ComponentRequest) => {
     submitForm(formData, getComponentNumber("policy"));
   })(event);
   setConfig({
     key: "",
     direction: LABELS.ASC,
   });
 };

  const renderButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Cancel"
          secondary
          buttonHandlerAction={onCloseModal}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized label={LABELS.Submit} primary />
      </div>
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={editedItem ? LABELS.EditScript : title!}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
    >
      <div className="flex justify-center">
        <div className="w-[500px]">
          <div className="flex flex-col w-full gap-y-4">
            <SIMPLInput
              name="name"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: LABELS.NameRequired,
                },
              }}
              label={LABELS.Name}
              placeholder={LABELS.Name}
              required
              id="name"
              fontWeight="bold"
              errorLabel={errors.name?.message}
            />

            <SIMPLInput
              name="description"
              control={control}
                rules={{
                required: {
                  value: true,
                  message: MESSAGES.MessagesDescriptionRequired,
                },
              }}
              required
              label={LABELS.Description}
              id="description"
              fontWeight="bold"
              errorLabel={errors.description?.message}
              placeholder={LABELS.Description}
            />
    <SIMPLInput
              name="content"
              control={control}
              type="textarea"
              required
                rules={{
                required: {
                  value: true,
                  message:MESSAGES.MessagesRequired,
                },
              }}
              rows={4}
              label={LABELS.Rules}
              id="content"
              fontWeight="bold"
              errorLabel={errors.content?.message}
              placeholder={""}
            />
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};
